/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
/**
 * UpdateMonthlyPayment Input Action
 */
export class UpdateMonthlyPaymentInput implements Msdyn365.IActionInput {
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `updateMonthlyPayment`;
    public getCacheObjectType = () => 'updateMonthlyPayment';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

//   Create a data model here or import one to capture the response of the action
export interface IUpdateMonthlyPaymentData {
    updateTotal: string | undefined;
}

/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new UpdateMonthlyPaymentInput();
};

/**
 *   Use this function to call your action and process the results as needed
 */
async function updateMonthlyPayment(input: UpdateMonthlyPaymentInput, ctx: Msdyn365.IActionContext): Promise<IUpdateMonthlyPaymentData> {
    return { updateTotal: '0' };
}

export default Msdyn365.createObservableDataAction<IUpdateMonthlyPaymentData>({
    id:'UpdateMonthlyPayment',
    action: <Msdyn365.IAction<IUpdateMonthlyPaymentData>>updateMonthlyPayment,
    input: createInput
});
